import React from "react";

export default function Hero() {
  return (
    <>
      <section className="hero" id="home">
        <div className="content-hero">
          <h1>Bienvenido a KAAB</h1>
          <div className="hero-desc">
            Clínica de especialidades odontológicas dedicada a la prevención
            y tratamiento de enfermedades buco-dentales y maxilofaciales.
          </div>
          <button className="hero-btn" onClick={() => window.location.href
            = "https://wa.me/529848079667?text=Hola%2C%20quisiera%20agendar%20una%20cita."}>
            Reserva tu cita
          </button>
        </div>

        <img
          src="/img/welcome.jpg"
          alt="welcome"
          className="hero-img"
        />
      </section>


      <section className="columns-section">
        <div className="columns-container">
          <div className="column-left">
            <h2>Kaab Dental Experts</h2>
            <p>
              Somos una clínica de especialistas odontológicos, con mas de 10 años de experiencia,
              comprometida con el diseño integral de sonrisas que combinan salud, funcionalidad y estética.
           </p>
            <p>
              Nuestro equipo está conformado por profesionales certificados en ortodoncia, estética dental,
              rehabilitación oral, endodoncia, cirugía y periodoncia, respaldados por tecnología digital avanzada y materiales de excelencia.
            </p>
            <p>
              Cada tratamiento se planifica con precisión científica y se ejecuta con sensibilidad estética, garantizando resultados naturales, cómodos y duraderos.
              en Kaab cuidamos tu confianza, tu bienestar y tu energía al sonreír.
            </p>
          </div>

          <div className="column-right">
            <div className="video">
              <video
                className="hero-video"
                controls
                autoPlay
                muted
                loop
              >
                <source src="/img/KaabVideo.mp4" type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
